
export const getText = (texts, language, id) => {
  if (!Array.isArray(texts)) {
    return '';
  }
  const fieldName = language == 'es' ? 'contenidoES' : 'contenidoEN';
  const text = texts.find(item => item.idTexto == id);

  if (text) {
    return text[fieldName] || '';
  }
  return '';
}

const cleanUnAllowedKeysInsideObject = (object2Clean, allowedKeys) => {
  const newObjectCleaned = { ...object2Clean };
  // looping
  const keys = Object.keys(object2Clean);

  keys.forEach((key) => {
    let allowed = false;

    allowedKeys.forEach((regItem) => {
      const regEx = new RegExp(regItem);

      if (regEx.test(key) && !allowed) {
        allowed = true;
      }
    });

    if (!allowed) {
      delete newObjectCleaned[key];
    }
  });

  return newObjectCleaned;
};

/**
 * getUrlParams
 * @param {bool} groupByObject object used to write the final result
 * @param {array} allowedKeys array of RegEx like: allowed: []
 * @returns {object} for example: {href: 'https://www.movistar.es', referrer: 'https://www.google.com'}
 */
const getUrlParams = (
  arg = {
    groupByObject: false,
    allowedParams: null,
    currentUrl: "",
  }
) => {
  let params = null;
  const { groupByObject, allowedParams, currentUrl } = arg;

  try {
    const currentUrlObj = new URL(currentUrl);
    const searchParams = new URLSearchParams(currentUrlObj.search);

    params = Object.fromEntries(searchParams.entries());
  } catch (err) {
    console.error(err);
  }
  
  // cleaning function
  if (Array.isArray(allowedParams) && params) {
    params = cleanUnAllowedKeysInsideObject(params, allowedParams);
  }
  
  // group by "." as object
  if (groupByObject) {
    let groupedParams = {};

    Object.entries(params).forEach(([paramsKey, value]) => {
      if (paramsKey.includes(".")) {
        const auxObj = makeUpObj(paramsKey, value);
        groupedParams = myAssign(groupedParams, auxObj);
      } else {
        groupedParams[paramsKey] = value;
      }
    });
    
    params = groupedParams;
  }

  return params;
};

export const giveRandomNumber = (min, max) => Math.floor(Math.random() * max) + min;

export const isSafariBrowser = () => {
  let res = false;
  try {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') !== -1) {
      if (!(ua.indexOf('chrome') > -1)) {
        res = true;
      }
    }
  } catch (err) { /* console.log('something failed on this browser'); */ }
  return res;
}

export const setCookie = (cName, value, exdays) => {
  const exdate = new Date();
  exdate.setDate(exdate.getDate() + exdays);
  const cValue = escape(value) + ((exdays == null) ? '' : `;expires=${exdate.toUTCString()};path=/`);
  document.cookie = `${cName}=${cValue}`;
}

export const getFirstPathOfUrl = (url) => {
  let res = '';
  if (url) {
    const tokken = url.split('/');
    if (tokken[1]) {
      res = `/${tokken[1]}`;
    }
  }
  return res;
}

export const normalizeString = (string) => {
  return string && string.normalize ? string.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() : '';
}

export const cmp2String = (str1 = '', str2 = '') => {
  const str1aux = normalizeString(str1);
  const str2aux = normalizeString(str2);
  return str1aux.indexOf(str2aux) > -1;
}

export const getCookie = (cName) => {
  let cValue = document.cookie;
  let cStart = cValue.indexOf(` ${cName}=`);
  if (cStart == -1) {
    cStart = cValue.indexOf(`${cName}=`);
  }
  if (cStart == -1) {
    cValue = null;
  } else {
    cStart = cValue.indexOf('=', cStart) + 1;
    let cEnd = cValue.indexOf(';', cStart);
    if (cEnd == -1) {
      cEnd = cValue.length;
    }
    cValue = unescape(cValue.substring(cStart, cEnd));
  }
  return cValue;
}

export const setCss2Element = (id, className) => {
  const element = document.getElementById(id);
  if (element) {
    if (element.classList.contains(className)) {
      element.classList.remove(className);
    } else {
      element.classList.add(className);
    }
  }
}

export const generateComponentId = (componentName, aditionalId = '', id = giveRandomNumber(1, 999)) => {
  return `${componentName}-${id}${aditionalId ? `-${aditionalId}` : ''}`;
}

export const deleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/`;
}

export const howAppIsRunning = () => {
  const { NODE_ENV } = process.env;
  return NODE_ENV;
}

export const areEqualsObject = (obj1, obj2) => JSON.stringify(obj1) == JSON.stringify(obj2)

export const getRandomBetween = max => (
  Math.floor(Math.random() * max) + 1  
)


export const sumArray = (arr) => {
  if (arr.length > 0) {
    return arr.reduce((sum, x) => sum + x);
  }
  return null
}


export const slugify = (string) => {
  const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
  const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
  const p = new RegExp(a.split('').join('|'), 'g')

  return string.toString().toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w\-]+/g, '') // Remove all non-word characters
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
}

export const slideDown = (id, finalheight, duration) => {
  const element = document.getElementById(id);
  const s = element.style;
  s.height = '0px';
  let y = 0;
  let currentFrame = 0;
  const framerate = 30;
  const oneSecond = 1000;
  const interval = oneSecond * duration / framerate;
  const totalframes = oneSecond * duration / interval;
  const heightincrement = finalheight / totalframes;
  const tween = () => {
    y += heightincrement;
    if (currentFrame < totalframes) {
      s.height = `${y}px`;
      currentFrame += 1;
      setTimeout(tween, interval);
    } else {
      s.height = 'auto';
    }
  }
  tween();
}

export const slideUp = (id, duration) => {
  const element = document.getElementById(id);
  const s = element.style;
  s.height = `${element.offsetHeight}px`;
  let y = element.offsetHeight; // 132
  // let currentFrame = 0;
  const framerate = 30;
  const oneSecond = 1000;
  const interval = oneSecond * duration / framerate; // 17
  const totalframes = (oneSecond * duration / interval); // 30
  const heightincrement = element.offsetHeight / totalframes; // 4.40000547
  // const heightincrementOneDecimal = parseInt(heightincrement.toFixed(2), 10)
  const tween = () => {
    y -= heightincrement;
    if (y < 0) {
      y = 0
    }
    s.height = `${y}px`;
    /* if (currentFrame <= totalFramesGood) {
      currentFrame += 1;
      setTimeout(tween, interval);
    } */
    if (y > 0) {
      // currentFrame += 1;
      setTimeout(tween, interval);
    }
  }
  tween();
}
